import { SHIFTS } from "@/constants/shifts";
import hasPlural from "./hasPlural";
import { parseTaken, percentOf } from "./takenMath";

/**
 * "Preuzeto" po firmi (preuzeto / poručeno) iz ReportMealsTabTaken.
 * Zahteva nasleđen stari tab: filteredTotal, filters, customSearch, selectedShifts.
 */
export default {
  mixins: [hasPlural],
  computed: {
    takenCompanies() {
      const searched = this.customSearch(
        this.filteredTotal,
        [{ value: "menu" }],
        this.filters.search
      );
      return searched
        .map((item) => this.toTakenCompany(item))
        .filter((company) => company.ordered > 0 || company.taken > 0);
    },
    summary() {
      const companies = this.filteredTotal
        .map((item) => this.parseTaken(item.total))
        .filter((total) => total.ordered > 0 || total.taken > 0);
      const taken = companies.reduce((sum, total) => sum + total.taken, 0);
      const ordered = companies.reduce((sum, total) => sum + total.ordered, 0);
      return {
        companies: companies.length,
        taken,
        ordered,
        percent: this.percentOf(taken, ordered),
      };
    },
  },
  methods: {
    toTakenCompany(item) {
      const total = this.parseTaken(item.total);
      const shifts = this.companyShifts(item);
      return {
        key: item.num,
        source: item,
        name: item.menu,
        taken: total.taken,
        ordered: total.ordered,
        complete: total.ordered > 0 && total.taken >= total.ordered,
        percent: this.percentOf(total.taken, total.ordered),
        shifts,
        shiftsText: shifts.length === 1 ? this.$t("report_mobile.shift_n", { n: shifts[0].id }) : "",
        shiftBadges: shifts.length > 1 ? shifts : [],
      };
    },
    /** Smene u kojima firma ima obroke, sa preuzetim / poručenim po smeni. */
    companyShifts(item) {
      return SHIFTS.map((shift) => ({ id: shift.id, ...this.parseTaken(item[shift.key]) })).filter(
        (shift) => shift.ordered > 0
      );
    },
    parseTaken,
    percentOf,
  },
};
